export default __webpack_public_path__ + "static/media/2.cc3879da.png";